import React from 'react';
import { Button, Header, Icon, Item, Segment } from 'semantic-ui-react';
import styled from 'styled-components';
import moment from 'moment';
import { NewsEntry } from '../../../../meta/types/news';
import { SidebarContext } from '../index';
import { COLLAPSED_SIDEBAR_WIDTH, EXTENDED_SIDEBAR_WIDTH } from '../../../../styles/Sidebar';
import TargetBlankLink from '../../../common/TargetBlankLink';

type NewsProps = {
  onClose: () => void;
};

const News = ({ onClose }: NewsProps) => {
  return (
    <SidebarContext.Consumer>
      {({ news, newsError, sidebarCollapsed }) => {
        return (
          <NewsStyled sidebarCollapsed={sidebarCollapsed}>
            <Header as="h3" attached="top">
              What's new
              <Button onClick={onClose} floated="right" icon style={{ background: 'transparent' }}>
                <Icon name="close" style={{ fontSize: '0.7em' }} />
              </Button>
            </Header>
            <Segment attached>
              {newsError !== undefined ? (
                <div>Error: {newsError}</div>
              ) : news === undefined ? (
                <div>Fetching news...</div>
              ) : (
                <NewsView entries={news} />
              )}
            </Segment>
          </NewsStyled>
        );
      }}
    </SidebarContext.Consumer>
  );
};

function NewsView({ entries }: { entries: NewsEntry[] }) {
  entries.sort((a, b) => b.id - a.id);

  return (
    <Item.Group divided>
      {entries.map(entry => (
        <NewsEntryView entry={entry} key={entry.id} />
      ))}
    </Item.Group>
  );
}

function NewsEntryView({ entry }: { entry: NewsEntry }) {
  return (
    <Item key={entry.id}>
      <Item.Content>
        <NewsEntryHeader>{entry.title}</NewsEntryHeader>
        <Item.Meta>{moment(entry.created).format('YYYY-MM-DD')}</Item.Meta>
        <Item.Description>
          {entry.message}
          <div />
        </Item.Description>
        <Item.Extra>
          {entry.link !== '' && entry.link !== undefined && <ClickToActionButton entry={entry} />}
        </Item.Extra>
      </Item.Content>
    </Item>
  );
}

function ClickToActionButton({ entry }: { entry: NewsEntry }) {
  const text = entry.clickToAction !== undefined ? entry.clickToAction : 'More';

  return <TargetBlankLink href={entry.link}>{text}</TargetBlankLink>;
}

type NewsStyleProps = {
  sidebarCollapsed: boolean;
};

const NewsStyled = styled.div<NewsStyleProps>`
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: ${props => (props.sidebarCollapsed ? COLLAPSED_SIDEBAR_WIDTH : EXTENDED_SIDEBAR_WIDTH)};
  width: 300px;
  background-color: rgb(251, 251, 252);
  border-right: 1px solid rgb(226, 219, 232);
  overflow-y: auto;
  overflow-x: hidden;
`;

const NewsEntryHeader = styled(Item.Header)`
  font-size: 1rem !important;
`;

export default News;
